export function getTags(tags, dependencies = []) {
  if (!dependencies.length) {
    return tags.map(tag => { return { label: tag.name, value: { label: tag.name, value: tag.value } } })
  } else {
    const dependency = dependencies[0]
    const sliced = dependencies.slice(1)
    const tag = tags.find(t => t.value === dependency.value)
    if (tag.subtags) {
      return getTags(tag.subtags, sliced)
    }
  }
}
